import { ClipboardIcon } from "@heroicons/react/24/outline";
import profile from "../../assets/uicon.png";
import React, { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";

const PaymentItems = ({ wallet }) => {
  // copy to clipboard
  const copyToClipBoard = () => {
    navigator.clipboard.writeText(wallet?.addy);
  };

  return (
    // <ClipboardIcon
    //         className="h-4 hover:cursor-pointer"
    //         onClick={copyToClipBoard}
    //       />
    <div className="lg:grid grid-cols-7 bg-white/60 rounded-sm text-white px-2 lg:py-2 py-3 my-3 text-sm space-x-2 ">
      <div className="col-span-1 my-2">
        {wallet?.logo ? (
          <>
            <img src={wallet?.logo} alt="profile" className="w-14 h-14" />
          </>
        ) : (
          <img src={profile} alt="profile" className="w-14 h-14" />
        )}
      </div>
      <div className="col-span-1 self-center space-y-2">
        <p className=" font-semibold text-white truncate">{wallet?.name}</p>
      </div>
      <div className="col-span-2 self-center space-y-2">
        <Tooltip title="click to copy address">
          <p
            onClick={() => {
              navigator.clipboard.writeText(`${wallet?.sender}`);
              alert('copied to clipboard')
            }}
            className=" font-semibold text-white truncate lg:-ml-3 cursor-pointer"
          >
            {wallet?.sender}
          </p>
        </Tooltip>
      </div>
      <div className="col-span-3 self-center space-y-2">
        <p className=" font-semibold text-white ">{wallet?.details}</p>
      </div>
    </div>
  );
};

export default PaymentItems;
